import { useTheme } from '@/contexts/ThemeProvider';

/**
 * Hook to determine if the current theme is dark or light
 * @returns boolean - true if theme is dark, false if light
 * 
 * @example
 * const isDark = useIsDarkTheme();
 * return isDark ? <DarkLogo /> : <LightLogo />;
 */
export const useIsDarkTheme = (): boolean => {
  const { isDarkTheme } = useTheme();
  return isDarkTheme;
};
